import type { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRightArrow = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path stroke="#001B71" strokeLinecap="square" strokeLinejoin="round" strokeWidth={1.5} d="M14.458 8.03H2" />
    <path
      stroke="#001B71"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.32 3.059 4.971 4.97L10.321 13"
    />
  </svg>
);
export default SvgRightArrow;
